__turbopack_context__.v({
  "caption": "RankingQuestion-module__XU-qDW__caption",
  "cellLabel": "RankingQuestion-module__XU-qDW__cellLabel",
  "chip": "RankingQuestion-module__XU-qDW__chip",
  "chipTaken": "RankingQuestion-module__XU-qDW__chipTaken",
  "optionCell": "RankingQuestion-module__XU-qDW__optionCell",
  "optionsRow": "RankingQuestion-module__XU-qDW__optionsRow",
  "otherInput": "RankingQuestion-module__XU-qDW__otherInput",
  "otherInputCell": "RankingQuestion-module__XU-qDW__otherInputCell",
  "rankingContainer": "RankingQuestion-module__XU-qDW__rankingContainer",
  "rankingStack": "RankingQuestion-module__XU-qDW__rankingStack",
  "rankingTable": "RankingQuestion-module__XU-qDW__rankingTable",
});
